// @ts-check
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  enumData,
  enumPage,
  enumPagination,
  enumRoutes,
  enumSQLS,
  enumTaskPhase,
  enumTaskType
} from "../../helpers/common.constants";
import {
  Button,
  Card,
  CardContent,
  Grid
} from "@mui/material";
import Link from "@mui/material/Link";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MessageHelper } from "../../helpers/MessageHelper";
import FinTimeActions from "../../actions/FinTimeActions";
import TaskActions from "../../actions/TaskActions";
import MyAlert from "../../controls/MyAlert";
import MyDate from "../../controls/MyDate";
import MyAutoSuggest from "../../controls/MyAutoSuggest";
import MyText from "../../controls/MyText";
import moment from "moment";
import MyDropDown from "../../controls/MyDropDown";
import DocumentActions from "../../actions/DocumentActions";
import TaskTemplateActions from "../../actions/TaskTemplateActions";

const RecordDefault = {
  // Main task properties
  ttTemplateID: 0  
}





const styles = {
  TDSmall: { mt: 0, mb: 0, pt: 0, pb: 0 },
};

export default function TaskTemplateCreate() {
  const [Record, setRecord] = useState(RecordDefault);
  const [Templates, setTemplates] = useState([]);
  const [MessageData, setMessageData] = useState({});
  const { TaskID, showMsg } = useParams();

  //Za Refreshiranje na strana mu treba;
  const location = useLocation();

  //za poraki pri loadiranje na strana
  const msgHelper = new MessageHelper();

  //za Navigacija
  const navigate = useNavigate();



  //****************************************** */
  //HOOKS SECTION HERE
  //****************************************** */

  //1 --> Ke se povika ovoj HOOK samo dokolku se SMENI url-ot poradi toa na new dodavame Ticks() za da forcirame refresh na strana na sekoj click
  useEffect(() => {
    initData();
  }, [location.pathname + "/" + location.search]);


  //****************************************** */
  //METHOD  SECTION HERE
  //****************************************** */
  const initData = () => {
    async function fetchData() {


      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let responses = await new TaskTemplateActions().GetAllAsync(null); // await LookupActions.InitAsync();

      if (!responses.error) {
        let templates = responses[0].data;
        setTemplates(templates)

        result = msgHelper.setPhase(enumPage.LoadSuccess);
        setMessageData(result);

      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };


  const saveData = () => {
    async function fetchData() {

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);
      let responses = await new TaskActions().NewTaskByTemplateAsync(Record);

      if (!responses.error) {
        let recordDb = responses[0].data;
        navigate(enumRoutes.Task_Edit.replace(":TaskID", recordDb.mtTaskID));
      } 
      else {
        //Finished  with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);

        setRecord((a) => ({
          ...a,
          ValidationMessages: result.ValidationMessages,
        }));
      }
    }

    fetchData();
  };

 
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log(name + ":" + value);
    setRecord((prevState) => ({ ...prevState, [name]: value }));
  };

 

  return (
    <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">

      <MyAlert {...MessageData} />
 
      <Grid container>
        <Grid item xs={12}>
          <MyDropDown
            Id="ttTemplateID"
            Record={Record}
            PlaceHolder="Choose Task Template"
            HandleChange={handleChange}
            Options={Templates}
            OptionsText="ttTemplateName"
            OptionsValue="ttTemplateID" 
          />
        </Grid>
      </Grid>

      <Grid container padding={1}>
        <Grid item xs={12} align="right">
          <Button
            name="btnSubmit"
            variant="contained"
            sx={{ mr: 1 }}
            color="success"
            size="small"
            disabled={MessageData.Loading}
            onClick={() => saveData()}
          >
            Create
          </Button>
        </Grid> 
      </Grid>

    </Typography>
  );
}

